import React from 'react';
import TiptapEditor from './editor/TiptapEditor';

const BitacoraEditor = ({
  contenidoHtml,
  onChange,
  onDebouncedChange,
  disabled = false,
  placeholder = 'Escribe aquí el análisis del Flujo de Caja...',
  contentClassName,
  toolbarExtra = null,
  mentionUsers = [],
  variableTags = [],
}) => (
  <div className="bitacora-editor-module">
    <TiptapEditor
      value={contenidoHtml}
      onChange={onChange}
      onDebouncedChange={onDebouncedChange}
      disabled={disabled}
      placeholder={placeholder}
      contentClassName={contentClassName}
      toolbarExtra={toolbarExtra}
      mentionUsers={mentionUsers}
      variableTags={variableTags}
    />
  </div>
);

export default BitacoraEditor;
